import { Injectable } from '@angular/core';
import { SignalRHubEndpoint, SignalRHubService } from '@navfleet/client/core/signal-r';
import {
    NotificationEventComment,
    NotificationEventCommentDeletedData,
    NotificationEventData,
    NotificationEventDeactivatedData,
    NotificationEventRemovedData,
    NotificationRuleData,
    NotificationRuleDeletedData,
    NotificationRuleVesselsEmailsUpdatedData,
} from '@navfleet/client/shared/models/notification';

export enum NotificationMethods {
    NotificationRuleAdded = 'NotificationRuleAdded',
    NotificationRuleUpdated = 'NotificationRuleUpdated',
    NotificationRuleDeleted = 'NotificationRuleDeleted',
    NotificationRuleVesselsEmailsUpdated = 'NotificationRuleVesselsEmailsUpdated',
    NotificationEventActivated = 'NotificationEventActivated',
    NotificationEventDeactivated = 'NotificationEventDeactivated',
    NotificationEventRemoved = 'NotificationEventRemoved',
    NotificationEventAcknowledged = 'NotificationEventAcknowledged',
    NotificationEventUnAcknowledged = 'NotificationEventUnAcknowledged',
    NotificationEventCommentAdded = 'NotificationEventCommentAdded',
    NotificationEventCommentUpdated = 'NotificationEventCommentUpdated',
    NotificationEventCommentDeleted = 'NotificationEventCommentDeleted',
}

export interface NotificationMethodCallback {
    [NotificationMethods.NotificationRuleAdded]: NotificationRuleData;
    [NotificationMethods.NotificationRuleUpdated]: NotificationRuleData;
    [NotificationMethods.NotificationRuleDeleted]: NotificationRuleDeletedData;
    [NotificationMethods.NotificationRuleVesselsEmailsUpdated]: NotificationRuleVesselsEmailsUpdatedData[];
    [NotificationMethods.NotificationEventActivated]: NotificationEventData;
    [NotificationMethods.NotificationEventDeactivated]: NotificationEventDeactivatedData;
    [NotificationMethods.NotificationEventRemoved]: NotificationEventRemovedData;
    [NotificationMethods.NotificationEventAcknowledged]: NotificationEventData;
    [NotificationMethods.NotificationEventUnAcknowledged]: NotificationEventData;
    [NotificationMethods.NotificationEventCommentAdded]: NotificationEventComment;
    [NotificationMethods.NotificationEventCommentUpdated]: NotificationEventComment;
    [NotificationMethods.NotificationEventCommentDeleted]: NotificationEventCommentDeletedData;
}

@Injectable({
    providedIn: 'root',
})
export class FleetEventNotificationSignalRService extends SignalRHubService<NotificationMethodCallback> {
    constructor() {
        super(SignalRHubEndpoint.Notification);
    }
}
